// General products share gallery markup, but retain their native purchase form.
// Keep this controller separate from the pillow-only guide/cart controller below.
(() => {
  document.querySelectorAll('.lp-pdp--general .lpp-gallery').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const images = [...gallery.querySelectorAll('[data-pdp-image]')];
    const thumbs = [...gallery.querySelectorAll('[data-pdp-thumb]')];
    const stage = gallery.querySelector('.lpp-stage');
    if (!images.length || !stage) return;
    let selected = 0, pointerStart, suppressEnlarge = false;
    const show = index => {
      selected = (index + images.length) % images.length;
      images.forEach((image, i) => { image.hidden = i !== selected; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === selected)));
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    gallery.querySelector('.lpp-thumbs')?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const index = thumbs.indexOf(document.activeElement);
      show(event.key === 'Home' ? 0 : event.key === 'End' ? images.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      thumbs[selected]?.focus();
    });
    stage.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch') pointerStart = { x: event.clientX, y: event.clientY };
    });
    stage.addEventListener('pointerup', event => {
      if (!pointerStart) return;
      const dx = event.clientX - pointerStart.x, dy = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5 || images.length < 2) return;
      show(selected + (dx < 0 ? 1 : -1));
      suppressEnlarge = true;
      setTimeout(() => { suppressEnlarge = false; }, 400);
    });
    stage.addEventListener('pointercancel', () => { pointerStart = null; });
    // Normal image clicks remain native high-resolution links, including without JS.
    stage.addEventListener('click', event => { if (suppressEnlarge) event.preventDefault(); });
    show(0);
  });
})();

(() => {
  const root = document.querySelector('[data-pdp]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('[data-pdp-form]'), main = root.querySelector('[data-main-add]'), sticky = root.querySelector('[data-sticky-add]'), status = root.querySelector('[data-pdp-status]');
  const caseSelector = form.querySelector('[data-pillowcase-selector]');
  if (caseSelector) { caseSelector.hidden = false; caseSelector.disabled = false; }
  let trigger, busy = false;
  const syncExternalOverlay = () => {
    const banner = document.querySelector('#shopify-pc__banner');
    const surface = banner?.querySelector('[role="dialog"], .shopify-pc__banner__dialog') || banner;
    const rect = surface?.getBoundingClientRect();
    const style = surface ? getComputedStyle(surface) : null;
    const visible = Boolean(surface && !surface.hidden && surface.getAttribute('aria-hidden') !== 'true' && rect?.width && rect?.height && rect.bottom > 0 && rect.top < innerHeight && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0');
    document.body.classList.toggle('lpp-consent-open', visible);
  };
  new MutationObserver(syncExternalOverlay).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-hidden', 'class', 'style'] });
  syncExternalOverlay();
  const close = (dialog) => dialog.close();
  const open = (dialog, from) => { root.querySelectorAll('dialog[open]').forEach(close); trigger = from; dialog.showModal(); document.documentElement.style.overflow = 'hidden'; };
  root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; trigger?.focus(); }));
  root.querySelector('[data-pdp-back]')?.addEventListener('click', event => {
    if (!document.referrer || history.length < 2) return;
    try {
      const previous = new URL(document.referrer);
      if (previous.origin === location.origin && previous.pathname === '/collections/childrens-pillows') {
        event.preventDefault(); history.back();
      }
    } catch (_) {}
  });
  let suppressZoom = false, pointerStart;
  const images = [...root.querySelectorAll('[data-pdp-image]')], thumbs = [...root.querySelectorAll('[data-pdp-thumb]')];
  function showImage(index) { images.forEach((image, i) => image.hidden = i !== index); thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index))); }
  const stage = root.querySelector('.lpp-stage');
  stage.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') pointerStart = { x: event.clientX, y: event.clientY }; });
  stage.addEventListener('pointerup', event => {
    if (!pointerStart) return;
    const dx = event.clientX - pointerStart.x, dy = event.clientY - pointerStart.y; pointerStart = null;
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5 || images.length < 2) return;
    showImage((images.findIndex(image => !image.hidden) + (dx < 0 ? 1 : -1) + images.length) % images.length);
    suppressZoom = true; setTimeout(() => { suppressZoom = false; }, 400);
  });
  stage.addEventListener('pointercancel', () => { pointerStart = null; });
  root.querySelector('.lpp-thumbs')?.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault(); let index = thumbs.indexOf(document.activeElement);
    index = event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
    showImage(index); thumbs[index]?.focus();
  });
  root.addEventListener('click', event => {
    const button = event.target.closest('button,a'); if (!button) return;
    if (button.matches('[data-close]')) close(button.closest('dialog'));
    if (button.matches('[data-open-guide]')) { event.preventDefault(); open(root.querySelector('[data-guide]'), button); }
    if (button.matches('[data-pdp-thumb]')) {
      root.querySelectorAll('[data-pdp-image]').forEach(image => image.hidden = image.dataset.pdpImage !== button.dataset.pdpThumb);
      root.querySelectorAll('[data-pdp-thumb]').forEach(thumb => thumb.setAttribute('aria-current', String(thumb === button)));
    }
    if (button.matches('[data-pdp-image]')) { event.preventDefault(); if (suppressZoom) return; const zoom = root.querySelector('[data-zoom]'); zoom.querySelector('img').src = button.href; zoom.querySelector('img').alt = button.querySelector('img').alt; open(zoom, button); }
  });
  root.querySelector('[data-height-form]').addEventListener('submit', event => {
    event.preventDefault(); const input = event.target.elements.height; const result = window.LilPilloSizes.recommend(input.value);
    const names = { mini: 'Mini', full: 'Full Size', large: 'Large' };
    const links = root.querySelector('[data-height-links]'); links.replaceChildren();
    result.sizes.forEach(size => {
      const name = names[size], sibling = [...root.querySelectorAll('[data-sibling-size]')].find(link => link.dataset.siblingSize === name);
      if (sibling) { const link = sibling.cloneNode(true); link.removeAttribute('aria-current'); links.append(link); }
      else { const note = document.createElement('p'); note.textContent = `${name} is not available in this pillow type. `; const link = document.createElement('a'); const url = new URL(links.dataset.collectionUrl, location.origin); url.searchParams.set('filter.p.m.custom.pillow_size', name); link.href = url.href; link.textContent = `View other pillow types in ${name}`; note.append(link); links.append(note); }
    });
    input.setAttribute('aria-invalid', String(Boolean(result.error)));
    root.querySelector('[data-height-result]').textContent = result.error || (result.sizes.length ? `${result.sizes.length > 1 ? 'Compare ' : 'Consider '}${result.sizes.map(size => names[size]).join(' and ')}` : 'This guide does not recommend a size for that height. You can still browse all pillows.');
  });
  const held = form.dataset.purchaseHeld === 'true';
  const quantity = form.querySelector('[name=quantity]');
  const variantSelect = form.querySelector('select[name=id]');
  const selectedCase = () => form.querySelector('[name=pillowcase_variant]:checked');
  const activeVariant = () => variantSelect?.selectedOptions[0];
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: form.dataset.currency || 'GBP' }).format(cents / 100);
  const syncPurchaseLabels = () => {
    const option = activeVariant();
    const soldOut = option ? option.dataset.available !== 'true' : form.dataset.mainAvailable !== 'true';
    const basePrice = Number(option?.dataset.priceCents || form.dataset.basePrice || 0);
    const casePrice = Number(selectedCase()?.dataset.casePrice || 0);
    const qty = Math.max(1, Number.parseInt(quantity.value, 10) || 1);
    const total = formatMoney((basePrice * qty) + casePrice);
    const label = held ? 'Currently unavailable' : soldOut ? 'Sold out' : `Add to bag — ${total}`;
    main.disabled = sticky.disabled = held || soldOut;
    main.textContent = sticky.textContent = label;
    root.querySelector('[data-sticky-price]').textContent = total;
    const chosen = selectedCase();
    const selection = form.querySelector('[data-case-selection]');
    if (selection) selection.textContent = chosen?.value ? `${chosen.dataset.caseTitle} selected — ${formatMoney(casePrice)}.` : selection.dataset.noCaseText;
  };
  syncPurchaseLabels();
  caseSelector?.addEventListener('change', syncPurchaseLabels);
  quantity.addEventListener('input', syncPurchaseLabels);
  variantSelect?.addEventListener('change', event => {
    const option = event.target.selectedOptions[0];
    const price = root.querySelector('[data-pdp-price]'); price.replaceChildren();
    if (option.dataset.compare) { const compare = document.createElement('s'); compare.textContent = option.dataset.compare; price.append(compare, ' '); }
    const current = document.createElement('span'); current.className = 'price__current'; current.textContent = option.dataset.price; price.append(current); price.setAttribute('aria-live', 'polite');
    form.dataset.basePrice = option.dataset.priceCents;
    syncPurchaseLabels();
  });
  const stickyBar = root.querySelector('.lpp-sticky');
  const syncSticky = () => { stickyBar.hidden = main.getBoundingClientRect().bottom > 0; };
  new IntersectionObserver(syncSticky, { threshold: 0 }).observe(main);
  document.addEventListener('scroll', syncSticky, { capture: true, passive: true });
  window.addEventListener('resize', syncSticky, { passive: true });
  syncSticky();
  async function refreshDrawer() {
    const url = new URL(root.dataset.cartUrl, location.origin); url.searchParams.set('section_id', 'lp-collection-cart');
    const response = await fetch(url); if (!response.ok) throw new Error('Basket display unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html'), body = doc.querySelector('[data-lp-cart]');
    if (!body) throw new Error('Basket display unavailable');
    root.querySelector('[data-cart-content]').replaceChildren(body);
    window.LilPilloCart.init(body, { onRefresh: refreshDrawer });
  }
  form.addEventListener('submit', async event => {
    if (!window.LilPilloCart) { if (caseSelector) caseSelector.disabled = true; return; }
    event.preventDefault(); if (busy || main.disabled || window.LilPilloCart.pending) return;
    const chosenCase = selectedCase();
    const extras = chosenCase?.value ? [{ id: chosenCase.value, quantity: 1 }] : [];
    busy = true; main.disabled = sticky.disabled = true; main.textContent = sticky.textContent = 'Adding…'; form.setAttribute('aria-busy', 'true'); status.textContent = '';
    let added = false, uncertain = false;
    try {
      await window.LilPilloCart.addBundle(form, extras); added = true;
      const success = chosenCase?.value
        ? caseSelector?.dataset.caseKind === 'spare'
          ? 'Pillow and spare pillowcase added to your bag.'
          : 'Pillow and pillowcase added to your bag.'
        : 'Pillow added to your bag.';
      status.textContent = success;
      open(root.querySelector('[data-pdp-cart]'), event.submitter); root.querySelector('[data-drawer-status]').textContent = success;
      await window.LilPilloCart.refresh(); await refreshDrawer();
    } catch (error) {
      uncertain = !added && (error.uncertain || !error.rejected);
      const message = added ? 'Your item was added. The bag display could not refresh. Open the full bag; do not add it again.' : uncertain ? 'We couldn’t confirm whether it was added. Check your bag before trying again.' : error.message;
      status.textContent = message; root.querySelector('[data-drawer-status]').textContent = message;
      if (uncertain) { const link = document.createElement('a'); link.href = root.dataset.cartUrl; link.textContent = ' Check your bag'; status.append(link); }
    } finally {
      busy = false; form.removeAttribute('aria-busy');
      if (uncertain) { main.disabled = sticky.disabled = true; main.textContent = sticky.textContent = 'Check bag first'; }
      else syncPurchaseLabels();
    }
  });
})();
